(function stateDefinition() {
    'use strict';
    angular.module('Entities')
        .service('calendarService', [
            'restUrlBuilder', function calendarService(restUrlBuilder) {

                this.get = function get(docTypeId, from, to) {

                    var params = { DocTypeId: docTypeId, From: from, To: to };

                    return restUrlBuilder.all('calendar')
                        .get({ params: params });
                };
            }
        ]);
})();